import { ConstData } from "./helpers"

export const TRANSACTION_TYPES: ConstData[] = [
  { title: "Direct Debit", value: 0 },
  { title: "Enrolment Fee", value: 1 },
  { title: "Late Fee", value: 2 },
  { title: "Custom", value: 3 },
  { title: "Record Payment", value: 4 },
  { title: "Record Credit", value: 5 },
  { title: "Waive", value: 6 },
  { title: "Refund", value: 7 },
  { title: "Transfer", value: 8 },
  { title: "Record Other Payment", value: 9 },
  { title: "Discount", value: 10 },
]

export const PAYMENT_TYPES: ConstData[] = [
  { title: "Direct Debit", value: 0 },
  { title: "Other Payment", value: 1 },
  { title: "Do Not Charge", value: 2 },
  { title: "Discount", value: 3 },
]

export const TRANSACTION_STATUSES: ConstData[] = [
  { title: "Unattempted", value: 0 },
  { title: "Failure", value: 1 },
  { title: "Success", value: 2 },
  { title: "Moved To Next Installment", value: 3 },
]

export const DISCOUNT_REMOVE_TYPE: ConstData[] = [
  { title: "Undo", value: 0 },
  { title: "Terminate", value: 1 },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/transactions.ts